export default {
  upKey: 38,
  downKey: 40,
  enterKey: 13
}
